import React from 'react';

interface PageLayoutProps {
  children: React.ReactNode;
  handleBackNavigation: () => void;
  renderStageProgression?: () => React.ReactNode;
  isEditable?: boolean;
  isPreview?: boolean;
  readOnlyMessage?: string;
  setIsPreview: (val: boolean) => void;
}

export const PageLayoutWrapper: React.FC<PageLayoutProps> = ({
  children,
  handleBackNavigation,
  renderStageProgression,
  isEditable = true,
  isPreview = false,
  readOnlyMessage = 'စာရွက်စာတမ်း၏ လုပ်ငန်းစဉ်အခြေအနေကြောင့် ပြင်ဆင်၍ မရပါ',
  setIsPreview,
}) => {
  return (
    <div className="max-w-3xl mx-auto my-6 font-sans print:my-0 print:max-w-none">
      {/* Top Header Navigation Bar */}
      <div className="w-full mb-4 flex flex-col gap-4 print:hidden">
        <div className="flex justify-between items-center">
          <button
            type="button"
            onClick={handleBackNavigation}
            className="flex items-center gap-1.5 px-3 py-2 rounded-lg bg-white border border-slate-200 hover:bg-slate-100 text-slate-700 font-medium text-xs shadow-sm transition"
          >
            ← နောက်သို့ ပြန်သွားမည်
          </button>

          {renderStageProgression && renderStageProgression()}
        </div>

        <div className="flex justify-between items-center">
          <div>
            {!isEditable && (
              <span className="text-xs text-slate-500 bg-slate-100 px-3 py-1.5 rounded-md border border-slate-200">
                🔒 {readOnlyMessage}
              </span>
            )}
          </div>
          <div>
            {isPreview ? (
              <div className="flex gap-2">
                <button
                  type="button"
                  onClick={() => window.print()}
                  className="bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-medium px-4 py-2 rounded-md shadow transition"
                >
                  🖨️ ထုတ်ယူမည် (Print)
                </button>
                <button
                  type="button"
                  onClick={() => setIsPreview(false)}
                  className="bg-slate-600 hover:bg-slate-700 text-white text-sm font-medium px-4 py-2 rounded-md shadow transition"
                >
                  ✏️ ပြင်ဆင်ရန်ပြန်သွားမည်
                </button>
              </div>
            ) : (
              <button
                type="button"
                onClick={() => setIsPreview(true)}
                className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-5 py-2 rounded-md shadow transition"
              >
                📄 ပရင့် (Go to Print Preview)
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Embedded Document */}
      {children}
    </div>
  );
};